import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import NavBar from "./components/NavBar";
import CapitalPage from "./components/sectors/CapitalPage";
import FoundationPage from "./components/sectors/FoundationPage";
import MediaPage from "./components/sectors/MediaPage";
import ContractingPage from "./components/sectors/ContractingPage";
import RealEstatePage from "./components/sectors/RealEstatePage";
import EcommercePage from "./components/sectors/EcommercePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <div className="min-h-screen bg-black">
          <NavBar />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/capital" element={<CapitalPage />} />
            <Route path="/foundation" element={<FoundationPage />} />
            <Route path="/media" element={<MediaPage />} />
            <Route path="/contracting" element={<ContractingPage />} />
            <Route path="/real-estate" element={<RealEstatePage />} />
            <Route path="/ecommerce" element={<EcommercePage />} />
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;